import { useDispatch, useSelector } from 'react-redux';
import { setEditUser, updateUser } from '../../redux/actions/clients';
import { StoreState } from '../../types/state';
import EditDialog from '../Common/EditDialog';
import useUserForm from './Users/useUserForm';

import { removeDuplicates } from '../../utils';

const EditUser = ({ currentClientId }: { currentClientId: string }) => {
  const dispatch = useDispatch();
  const user = useSelector((state: StoreState) => state.clients.editUser);

  const { userForm, updated } = useUserForm(currentClientId, true);

  if (!user || !updated) return null;

  const handleUpdate = (data: any) => {
    debugger;
    data.ManagedProperties = removeDuplicates(data.ManagedProperties);

    dispatch(updateUser({ data, id: currentClientId }));
    dispatch(setEditUser(undefined));
  };
  return (
    <EditDialog
      update={handleUpdate}
      onClose={() => dispatch(setEditUser(undefined))}
      formSchema={userForm}
      formData={user}
      noValidate={
        userForm.properties.ManagedProperties?.items?.anyOf?.length > 500
      }
    />
  );
};
export default EditUser;
